import { render, staticRenderFns } from "./RegionNode.vue?vue&type=template&id=a70262c4&scoped=true&"
import script from "./RegionNode.vue?vue&type=script&lang=js&"
export * from "./RegionNode.vue?vue&type=script&lang=js&"
import style0 from "./RegionNode.vue?vue&type=style&index=0&id=a70262c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70262c4",
  null
  
)

export default component.exports